
export default {
  head() {
    return {
      title:
        "Agence Google Ads | SEA à Neuilly-sur-Seine dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Neuilly-sur-Seine certifiée Google Partner, soutient les entreprises neuilléennes pour accroître leur visibilité en ligne et gagner de nouveaux clients.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Agence Google Ads à Neuilly-sur-Seine dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Neuilly-sur-Seine certifiée Google Partner, soutient les entreprises neuilléennes pour accroître leur visibilité en ligne et gagner de nouveaux clients.",
        },
      ],
    };
  },
};
